export const COMPLETED_WORKFLOW_WITH_UNSUPPORTED_VERSION =
  'COMPLETED_WORKFLOW_WITH_UNSUPPORTED_VERSION';
export const INCOMPLETE_WORKFLOW_WITH_UNSUPPORTED_VERSION =
  'INCOMPLETE_WORKFLOW_WITH_UNSUPPORTED_VERSION';
